import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3 text-primary" }, "Links", -1)
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _createElementVNode("a", {
              href: link.url,
              target: "_blank"
            }, _toDisplayString(link.title), 9, _hoisted_4)
          ]))
        }), 128))
      ])
    ])
  ]))
}